export default __webpack_public_path__ + "static/media/19.49e7e1cc.png";